import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import UserAvatar from "../components/UserAvatar";
import ServiceImageGallery from "../components/ServiceImageGallery";
import { getServiceAvailablePlaces, hasUpcomingCreneau, matchesPrestationFilter } from "../utils/serviceUtils";
const DEFAULT_SERVICE_IMAGE = "/default-service.png";

const ServiceList = () => {
  const [services, setServices] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [customCategory, setCustomCategory] = useState("");
  const [filtered, setFiltered] = useState([]);
 // const [notes, setNotes] = useState({});
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedPrestationFilter, setSelectedPrestationFilter] = useState("Tous");

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const isFixedIndividualService = (s) => {
    const type = String(s?.typeCours || "").toLowerCase();
    const hasFixedDate = !s?.dateAConvenir && Array.isArray(s?.dateService) && s.dateService.length > 0;
    return (type.includes("individuelle") || !type) && hasFixedDate;
  };

  const isServiceActive = (s) =>
    s?.isActive !== false &&
    s?.active !== false &&
    s?.desactive !== true &&
    s?.status !== "inactive";

const categories = [
  { nom: "Animaux & monde vivant", couleur: "#B36A5E" },
  { nom: "Architecture & urbanisme", couleur: "#E3CD8B" },
  { nom: "Arts vivants", couleur: "#F27438" },
  { nom: "Arts visuels", couleur: "#F39C12" },
  { nom: "Artisanat", couleur: "#CA7C5C" },
  { nom: "Bien-être", couleur: "#27AE60" },
  { nom: "Décoration & aménagement", couleur: "#e76f51" },
  { nom: "Développement personnel", couleur: "#9B59B6" },
  { nom: "Écologie & durabilité", couleur: "#7AA95C" },
  { nom: "Écriture & littérature", couleur: "#C89F9C" },
  { nom: "Entrepreneuriat & innovation", couleur: "#427AA1" },
  { nom: "Finances personnelles & économie", couleur: "#E8EDDF" },
  { nom: "Formation, enseignement & accompagnement", couleur: "#C8574D" },
  { nom: "Gastronomie & art culinaire", couleur: "#FFAE9D" },
  { nom: "Humanitaire & droits humains", couleur: "#7C4C53" },
  { nom: "Inclusion & solidarité", couleur: "#FF584D" },
  { nom: "Informatique & numérique", couleur: "#3498DB" },
  { nom: "Jeux & expériences interactives", couleur: "#0FAC71" },
  { nom: "Management & organisation", couleur: "#9281C0" },
  { nom: "Marketing, Communication & Événementiel", couleur: "#4A919E" },
  { nom: "Médias, journalisme & storytelling", couleur: "#A92831" },
  { nom: "Musique & son", couleur: "#FFBF66" },
  { nom: "Nature, jardinage & permaculture", couleur: "#B7CE66" },
  { nom: "Parentalité & famille", couleur: "#EA5863" },
  { nom: "Politique, citoyenneté & engagement sociétal", couleur: "#585B4C" },
  { nom: "Relations & développement social", couleur: "#E74C3C" },
  { nom: "Santé", couleur: "#EDCDFA" },
  { nom: "Sciences & technologies", couleur: "#62B9CB" },
  { nom: "Sport, loisirs physiques & outdoor", couleur: "#5CAFE7" },
  { nom: "Spiritualité", couleur: "#FFE361" },
  { nom: "Stylisme & mode", couleur: "#F0A1BF" },
  { nom: "Thérapies alternatives", couleur: "#A4BD01" },
  { nom: "Voyage, tourisme & interculturalité", couleur: "#7DC2A5" },


  { nom: "Autres", couleur: "#6A5ACD" }
];

  // Fermer dropdown au clic extérieur
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

useEffect(() => {
  const u = JSON.parse(localStorage.getItem("user"));
  setUser(u);

  const handleCreditsUpdate = (e) => {
    if (e?.detail) {
      setUser(e.detail); // ✅ utilisateur complet
    }
  };

  window.addEventListener("creditsUpdated", handleCreditsUpdate);

  return () => {
    window.removeEventListener("creditsUpdated", handleCreditsUpdate);
  };
}, []);



  // Charger services, notes, user... (inchangé)
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get("https://backend-qybe.onrender.com/api/services"); //
        const servicesData = res.data;

        const servicesWithRemaining = await Promise.all(
          servicesData.map(async (s) => {
            const fallbackCapacity = getServiceAvailablePlaces(s);
            const hasDefinedCapacity = Number.isFinite(fallbackCapacity) && fallbackCapacity > 0;

            try {
              const countRes = await axios.get(`https://backend-qybe.onrender.com/api/reservations/count/${s._id}`);
              const placesRestantes = hasDefinedCapacity
                ? Math.max(fallbackCapacity - (countRes.data.count || 0), 0)
                : isFixedIndividualService(s)
                  ? 1
                  : 0;

              return { ...s, placesRestantes, hasDefinedCapacity: hasDefinedCapacity || placesRestantes > 0 };
            } catch {
              const fallbackPlaces = isFixedIndividualService(s) ? 1 : fallbackCapacity;
              return { ...s, placesRestantes: fallbackPlaces, hasDefinedCapacity: fallbackPlaces > 0 };
            }
          })
        );

        const available = servicesWithRemaining.filter((s) => {
          const isVisibleFixedIndividual = isFixedIndividualService(s) && hasUpcomingCreneau(s) && isServiceActive(s);
          return (s.placesRestantes > 0 || isVisibleFixedIndividual) && isServiceActive(s) && hasUpcomingCreneau(s);
        });

        // Trier : sans date en premier, puis par date croissante
        const sorted = [...available].sort((a, b) => {
          const aHasDate = !a.dateAConvenir && Array.isArray(a.dateService) && a.dateService.length > 0;
          const bHasDate = !b.dateAConvenir && Array.isArray(b.dateService) && b.dateService.length > 0;
          if (!aHasDate && !bHasDate) return 0;
          if (!aHasDate) return -1;
          if (!bHasDate) return 1;
          return new Date(a.dateService[0]) - new Date(b.dateService[0]);
        });

        setServices(sorted);
        setFiltered(sorted);
        sorted.forEach(s => loadNoteForService(s._id));
      } catch (err) {
        console.error(err);
      }
    };
    fetchServices();
  }, []);

  const loadNoteForService = async (id) => { /* ... identique à avant ... */ };

  // Filtre (inchangé)
  useEffect(() => {
    const lowerSearch = search.toLowerCase();
    const hasCustom = selectedCategories.includes("Autres") && customCategory.trim();

    const results = services.filter(s => {
      const matchSearch = s.titre?.toLowerCase().includes(lowerSearch);
      const serviceCats = Array.isArray(s.categories) ? s.categories : (s.categories ? [s.categories] : []);

      const matchCat = selectedCategories.length === 0 || selectedCategories.some(cat => {
        if (cat === "Autres" && hasCustom) {
          return serviceCats.some(sc => sc?.toLowerCase() === customCategory.trim().toLowerCase());
        }
        return serviceCats.some(sc => sc?.toLowerCase() === cat.toLowerCase());
      });

      const matchPrestation = matchesPrestationFilter(s, selectedPrestationFilter);

      return matchSearch && matchCat && matchPrestation;
    });

    setFiltered(results);
  }, [search, selectedCategories, customCategory, selectedPrestationFilter, services]);

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("user"));
    setUser(u);
  }, []);

  const toggleCategory = (cat) => {
    setSelectedCategories(prev =>
      prev.includes(cat) ? prev.filter(c => c !== cat) : [...prev, cat]
    );
  };

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: 'var(--app-background)' }}>
      <div className="max-w-6xl mx-auto">
        {/* En-tête */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold flex items-center gap-2" style={{ fontFamily: "Fraunces, serif" }}>
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-[var(--accent-primary)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Services disponibles
          </h2>
          {user?.role === "createur" && (
            <button onClick={() => navigate("/create-service")} className="btn-primary px-4 py-2">
              + Ajouter un créneau
            </button>
          )}
        </div>

        {/* Barre de recherche + filtre */}
        <div className="flex flex-col md:flex-row gap-4 mb-6">
          <input
            type="text"
            placeholder="Rechercher..."
            className="flex-1 border px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="mb-6 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-wrap gap-3">
            {["Tous", "Distanciel", "Paris", "Genève"].map((filterValue) => {
              const isActive = selectedPrestationFilter === filterValue;

              return (
                <button
                  key={filterValue}
                  type="button"
                  onClick={() => setSelectedPrestationFilter(filterValue)}
                  className={isActive
                    ? "rounded-full border border-[var(--accent-primary)] bg-[var(--accent-primary)] px-4 py-2 text-sm font-semibold text-white"
                    : "rounded-full border border-[var(--accent-fuchsia)] bg-white px-4 py-2 text-sm font-semibold text-[var(--accent-fuchsia)] transition-colors hover:bg-[var(--accent-primary-soft)]"}
                >
                  {filterValue !== "Tous" && (
                    <svg xmlns="http://www.w3.org/2000/svg" className="inline w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  )}
                  {filterValue}
                </button>
              );
            })}
          </div>

          <div className="relative w-full lg:w-64" ref={dropdownRef}>
            <div
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="border border-gray-300 px-4 py-2.5 rounded-full focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)] cursor-pointer bg-white w-full text-left flex items-center justify-between"
            >
              <span className="font-medium text-gray-700">Catégories</span>
              {selectedCategories.length > 0 && (
                <span className="ml-3 inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-[var(--accent-primary-soft)] px-2 text-xs font-bold text-[var(--accent-primary)]">
                  {selectedCategories.length}
                </span>
              )}
            </div>

            {dropdownOpen && (
              <div className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-y-auto">
                {categories.map((cat) => (
                  <label
                    key={cat.nom}
                    className={`flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer ${selectedCategories.includes(cat.nom) ? "text-[var(--accent-primary)]" : "text-gray-800"}`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedCategories.includes(cat.nom)}
                      onChange={() => toggleCategory(cat.nom)}
                      className="mr-2 accent-[var(--accent-primary)]"
                    />
                    <span className={selectedCategories.includes(cat.nom) ? "font-medium" : ""}>{cat.nom}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Champ "Autres" si sélectionné */}
        {selectedCategories.includes("Autres") && (
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Votre catégorie personnalisée :
            </label>
            <input
              type="text"
              placeholder="Ex: Photographie, Danse..."
              className="border px-3 py-2 rounded w-full md:w-96 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
              value={customCategory}
              onChange={(e) => setCustomCategory(e.target.value)}
            />
          </div>
        )}

        {/* Liste des services (en grille ou liste, selon vous) */}
       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            {filtered.map((service) => (
              <div
                key={service._id}
                className="bg-white rounded-xl shadow hover:shadow-lg transition flex flex-col cursor-pointer"
                onClick={() => navigate(`/service/${service._id}`)}
              >
                {/* Image Galerie */}
                <ServiceImageGallery 
                  images={Array.isArray(service.images) && service.images.length > 0 ? service.images : [DEFAULT_SERVICE_IMAGE]}
                  title={service.titre}
                  compact={true}
                  className="rounded-t-xl"
                />

                <div className="p-4 flex flex-col flex-1">
                  {/* Créateur + Note */}
                  <div className="flex items-center mb-2">
                    <UserAvatar
                      photo={service.createur?.photo}
                      name={service.createur?.name}
                      prenom={service.createur?.prenom}
                      className="w-9 h-9 mr-2"
                    />
                    <div>
                     <span className="font-medium text-sm">
  {service.createur
    ? `${service.createur.prenom ?? ""} ${service.createur.name ?? ""}`
    : "Créateur inconnu"}
</span>

                      {/*  
                      {notes[service._id] && (
                        <div className="flex items-center text-yellow-500 text-xs mt-1">
                          <span>⭐</span>
                          <span className="text-gray-600 ml-1">
                            {notes[service._id].note}
                          </span>
                        </div>
                      )}
                        */}
                    </div>
                  </div>

                  {/* Titre */}
                  <h3 className="text-md font-semibold mb-1">
                    {service.titre}
                  </h3>

                  {/* ✅ Crédits */}
                  <div className="flex items-center justify-between mt-3">
                    <span className="font-semibold credits-fuchsia">
                      {service.creditsProposes} crédits
                    </span>
                    <button className="w-20 btn-primary py-2 text-sm">
                      Réserver
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
  );
};

export default ServiceList;
